export default __webpack_public_path__ + "static/media/back-car-cart.5b13751a.png";